export default __webpack_public_path__ + "icon-edit-hover.png?0cb95f6513c89e15998ecfa6d81bd258";